import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { UserProfile, Users } from "../../../../Constants/Constants";
import { Fragment } from "react/jsx-runtime";
import UserData from "./ProfileUsers/UserData";
import FirstData from "./FirstData";
import SecondData from "./SecondData";
import ThirdData from "./ThirdData";
import ForthData from "./ForthData";

const UsersProfileContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={UserProfile} parent={Users} />
      <Container fluid>
        <div className="user-profile only-users">
          <Row>
            <UserData />
            <FirstData />
            <SecondData />
            <ThirdData />
            <ForthData />
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default UsersProfileContainer;
